// NPM Imports
import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Loader } from "../../revvComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { buttonClickEvent } from "../../gtm/gtmutils";

// Components Imports

// Actions Imports

// Internal Imports

// Destructuring

// Declarations
const GLOBAL_META_FIELD = "global_mf";

const GLOBAL_META_FIELD_LABEL_MAP = {
  TEMPLATE: "Template details",
  DOCUMENT: "Document details",
};

export default function MetaFieldViewAccordion({
  activePaneView,
  toggleCurrentView,
  metaFieldPanes,
  mode,
}) {
  return (
    <div className="metafield-view-accordion">
      {metaFieldPanes.map(pane => (
        <span
          key={pane.id}
          className={`metafield-view-accordion-item ${
            activePaneView === pane.id ? " active-view-accordion " : " "
          }`}
          onClick={() => {
            toggleCurrentView(pane.id);
            buttonClickEvent(pane.gtmAction);
          }}
          onKeyPress={() => {}}
          role="button"
          tabIndex={"0"}>
          <FontAwesomeIcon
            icon={pane.icon}
            className="metafield-view-accordion-itemicon"
          />
          {pane.id === GLOBAL_META_FIELD
            ? GLOBAL_META_FIELD_LABEL_MAP[mode]
            : pane.label}
        </span>
      ))}
    </div>
  );
}
